<template>
    <div class="result-item-group">
        <div class="tc-sidebar-right-items-body-card">
            <img class="tc-sidebar-right-items-body-card-image"
                 :src="getImage(item.image)">
            <div class="tc-sidebar-right-items-body-card-description">
                <div class="tc-sidebar-right-items-body-card-description-text"
                     :title="item.name">
                    {{item.name}}
                </div>
                <div class="tc-sidebar-right-items-body-card-description-count">
                    1 шт.
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import { useStoreCaseConfiguration } from '@/Store/storeCaseConfiguration';
import { getImage } from '@/libs/getImage';

export default {
    name: 'ResultCaseCard',
    props: [
        'item',
    ],
    setup() {
        const storeCaseConfiguration = useStoreCaseConfiguration();
        return {
            storeCaseConfiguration,
        };
    },
    methods: {
        getImage,
    },
    computed: {

    },
};
</script>

<style scoped lang="scss">
@import "CSS/rigtSIdebarItems";
</style>
